import { useEffect, useState } from "react";
import { connect } from "react-redux";
import ReactLoading from "react-loading";
import { Container, Grid, Table, TableRow, TableBody, TableCell } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { useHistory } from "react-router-dom";

import { Wallet, initMercadoPago } from "@mercadopago/sdk-react";

import { toast } from "react-toastify";

import { updateStore } from "redux/actions/Store";
import { saveToken } from "redux/actions/PanelAdmin";

import { Img_distribution, colors } from "../../../values";
import { useStyles } from "../styles";

import { verifyLogin } from "utils/login";

import { formatMoney, checkPrice } from "utils";
import { checkShipmet } from "utils/shipment";
import { searchCoupon } from "utils/products";
import { Ic_check, Ic_uncheck } from "values";
import { generatePayment } from "utils/shopping";

import { Close, Plus, Minus } from "./Buttons";
import Header from "./Header";

initMercadoPago(process.env.REACT_APP_MERCADO_PAGO_KEY_PROD);

const styles = makeStyles((theme) => ({
  stack: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #e0e0e0",
    padding: "8px 0",
    gap: 20,
    [theme.breakpoints.down("md")]: {
      display: "block",
      padding: "5px 0",
      gap: 0,
    },
  },
  button_apply: {
    position: "absolute",
    right: 10,
    top: "50%",
    transform: "translateY(-50%)",
    background: colors.red,
    color: "white",
    border: "none",
    cursor: "pointer",
    fontFamily: "m_semi_bold",
    height: 30,
    width: 70,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  input: {
    width: "100%",
    height: 40,
    padding: "0px 10px",
    boxSizing: "border-box",
    background: colors.light_gray,
    border: "none",
    borderRadius: 7,
  },
  button: {
    width: "100%",
    height: 50,
    background: colors.red,
    color: "white",
    border: "none",
    cursor: "pointer",
    fontFamily: "m_extra_bold",
    marginTop: 20,
    fontSize: 20,
  },
}));

const Check = ({ shippingType, onClick, value, text }) => {
  return (
    <div style={{ display: "flex", cursor: "pointer" }} onClick={() => onClick(value)}>
      <img alt="" src={shippingType === value ? Ic_check : Ic_uncheck} draggable={false} />
      <p style={{ fontSize: 12, fontWeight: 400, marginLeft: 5, userSelect: "none" }}>{text}</p>
    </div>
  );
};

const Aside = (props) => {
  const {
    steps,
    rol,
    sell,
    subtotal,
    coupon,
    setCoupon,
    validateCoupon,
    loading,
    discount,
    shippingType,
    setShippingType,
    delivery,
    total,
    setSteps,
    loading2,
    totalProducts,
    children,
  } = props;
  const classes = styles();

  return (
    <div style={{ position: "relative", padding: 20, boxShadow: "0px 0px 20px 0px rgba(0,0,0,0.1)", marginTop: 25 }}>
      <div className={classes.stack} style={{ display: "flex" }}>
        <p style={{ margin: 0, fontFamily: "av_book", userSelect: "none" }}>Subtotal</p>
        <p style={{ margin: 0, fontFamily: "m_semi_bold", userSelect: "none" }}>{`$ ${formatMoney(subtotal)} MXN`}</p>
      </div>

      {steps <= 2 && (
        <div className={classes.stack} style={{ display: "flex" }}>
          <p style={{ margin: 0, fontFamily: "av_book", userSelect: "none" }}>Cupón</p>
          <div style={{ position: "relative", width: "80%", maxWidth: 300 }}>
            <input type="text" className={classes.input} value={coupon} onChange={(e) => setCoupon(e.target.value)} />
            <button onClick={validateCoupon} className={classes.button_apply}>
              {loading && <ReactLoading type={"bubbles"} color={"white"} style={{ fill: "#fff", height: 30, width: 30 }} />}
              {!loading && "Aplicar"}
            </button>
          </div>
        </div>
      )}

      <div className={classes.stack} style={{ display: "flex" }}>
        <p style={{ margin: 0, fontFamily: "av_book", userSelect: "none" }}>Descuento</p>
        <p style={{ margin: 0, fontFamily: "m_semi_bold", userSelect: "none" }}>{`$ ${formatMoney(discount)} MXN`}</p>
      </div>

      {/* {rol !== "Distribuitor" && (
        <div className={classes.stack} style={{ display: "flex", justifyContent: "space-around" }}>
          <Check shippingType={shippingType} onClick={setShippingType} value="SLOW" text="Envío Estandar" />
          <Check shippingType={shippingType} onClick={setShippingType} value="FAST" text="Envío Express" />
        </div>
      )} */}

      <div className={classes.stack} style={{ display: "flex" }}>
        <p style={{ margin: 0, fontFamily: "av_book", userSelect: "none" }}>Costo de envio</p>
        <p style={{ margin: 0, fontFamily: "m_semi_bold", userSelect: "none" }}>{`$ ${formatMoney(delivery)} MXN`}</p>
      </div>

      {totalProducts === 1 && (
        <div style={{ width: "100%", backgroundColor: colors.yellow, padding: "15px 15px", boxSizing: "border-box", marginTop: 8 }}>
          <p style={{ margin: 0, fontFamily: "m_semi_bold", userSelect: "none" }}>Envio en $115 MXN a partir de 2 piezas.</p>
        </div>
      )}

      <div className={classes.stack} style={{ borderBottom: "none", display: "flex" }}>
        <p style={{ margin: 0, fontFamily: "m_semi_bold", userSelect: "none" }}>Total</p>
        <p style={{ margin: 0, fontFamily: "m_semi_bold", userSelect: "none", fontSize: 20 }}>{`$ ${formatMoney(total)} MXN`}</p>
      </div>

      {sell === true && steps <= 2 && (
        <button
          type="button"
          onClick={setSteps}
          className={classes.button}
          style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
          {loading2 && <ReactLoading type={"bubbles"} color={"white"} style={{ fill: "#fff", height: 50, width: 50 }} />}
          {!loading2 && "CONTINUAR"}
        </button>
      )}

      {children}
    </div>
  );
};

const Login = () => {
  const classes = styles();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (loading) return;
    setLoading(true);

    const res = await verifyLogin(email, password);
    if (res.flag) {
      localStorage.setItem("upee-key", res.token);
      localStorage.setItem("upee-name", res.data.name);
      localStorage.setItem("upee-lastname", res.data.lastName);
      localStorage.setItem("upee-picture", res.data.picture);
      localStorage.setItem("upee-rol", res.data.role);
      localStorage.setItem("upee-email", res.data.email);
      saveToken(res.token, res.data.name, res.data.lastName, res.data.picture, res.data.role, res.data.email);
    } else {
      toast.warn("Por favor verifica que tus datos esten correctos.");
    }

    setLoading(false);
  };

  return (
    <form
      onSubmit={handleLogin}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        marginTop: 50,
        borderTop: `2px solid ${colors.gray}`,
        paddingTop: 30,
      }}
    >
      <div style={{ width: "100%", maxWidth: 550, boxShadow: "0px 0px 20px 0px rgba(0,0,0,0.1)", padding: 30 }}>
        <p style={{ fontFamily: "m_semi_bold", fontSize: 20, margin: 0, paddingTop: 30 }}>Inicia Sesión</p>
        <p style={{ fontFamily: "m_medium", fontSize: 16, margin: 0, paddingTop: 20 }}>
          Queremos acompañarte en todo el proceso. Accede para tener control total de tus compras y su seguimiento.
        </p>

        <div style={{ marginTop: 12 }}>
          <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>Correo</label>
          <input type="email" className={classes.input} value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>

        <div style={{ marginTop: 12 }}>
          <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>Contraseña</label>
          <input type="text" className={classes.input} value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>

        <button type="submit" className={classes.button} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          {loading && <ReactLoading type={"bubbles"} color={"white"} style={{ fill: "#fff", width: 60 }} />}
          {!loading && "CONTINUAR"}
        </button>
      </div>
    </form>
  );
};

const Contact = (props) => {
  const {
    data,
    name,
    setName,
    lastName,
    setLastName,
    phone,
    setPhone,
    address,
    setAddress,
    numExt,
    setNumExt,
    numInt,
    setNumInt,
    state,
    setState,
    municipality,
    setMunicipality,
    area,
    setArea,
    postalCode,
    setPostalCode,
    email,
    setEmail,
    saveData,
    setSaveData,
  } = props;
  const classes = styles();

  useEffect(() => {
    if (data) {
      setName(data.name);
      setLastName(data.lastName);
      setPhone(data.phone);
      setAddress(data.address);
      setNumExt(data.numExt);
      setNumInt(data.numInt);
      setState(data.state);
      setMunicipality(data.municipality);
      setArea(data.area);
      setPostalCode(data.postalCode);
      setEmail(data.email);
    }
  }, [data]);

  return (
    <div>
      <div className={classes.stack} style={{ borderBottom: "none" }}>
        <div style={{ width: "100%", paddingBottom: 10 }}>
          <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>Nombre</label>
          <input type="text" className={classes.input} value={name} onChange={(e) => setName(e.target.value)} required />
        </div>

        <div style={{ width: "100%", paddingBottom: 10 }}>
          <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>Apellido</label>
          <input type="text" className={classes.input} value={lastName} onChange={(e) => setLastName(e.target.value)} required />
        </div>
      </div>

      <div className={classes.stack} style={{ borderBottom: "none" }}>
        <div style={{ width: "100%", paddingBottom: 10 }}>
          <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>Teléfono</label>
          <input type="tel" className={classes.input} value={phone} onChange={(e) => setPhone(e.target.value)} required />
        </div>

        <div style={{ width: "100%", paddingBottom: 10 }}>
          <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>Correo</label>
          <input type="email" className={classes.input} value={email} onChange={(e) => setEmail(e.target.value)} disabled />
        </div>
      </div>

      <div className={classes.stack} style={{ borderBottom: "none" }}>
        <div style={{ width: "100%", paddingBottom: 10 }}>
          <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>Calle</label>
          <input type="text" className={classes.input} value={address} onChange={(e) => setAddress(e.target.value)} required />
        </div>

        <div className={classes.stack} style={{ borderBottom: "none", width: "100%" }}>
          <div style={{ width: "100%", paddingBottom: 10 }}>
            <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>Num Ext</label>
            <input type="text" className={classes.input} value={numExt} onChange={(e) => setNumExt(e.target.value)} />
          </div>

          <div style={{ width: "100%", paddingBottom: 10 }}>
            <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>Num Int</label>
            <input type="text" className={classes.input} value={numInt} onChange={(e) => setNumInt(e.target.value)} />
          </div>
        </div>
      </div>

      <div className={classes.stack} style={{ borderBottom: "none" }}>
        <div style={{ width: "100%", paddingBottom: 10 }}>
          <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>Estado</label>
          <input type="text" className={classes.input} value={state} onChange={(e) => setState(e.target.value)} required />
        </div>

        <div style={{ width: "100%", paddingBottom: 10 }}>
          <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>Municipio</label>
          <input type="text" className={classes.input} value={municipality} onChange={(e) => setMunicipality(e.target.value)} required />
        </div>
      </div>

      <div className={classes.stack} style={{ borderBottom: "none" }}>
        <div style={{ width: "100%", paddingBottom: 10 }}>
          <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>Colonia</label>
          <input type="text" className={classes.input} value={area} onChange={(e) => setArea(e.target.value)} required />
        </div>

        <div style={{ width: "100%", paddingBottom: 10 }}>
          <label style={{ fontFamily: "m_semi_bold", fontSize: 14, margin: 0, paddingLeft: 10 }}>CP</label>
          <input type="text" className={classes.input} value={postalCode} onChange={(e) => setPostalCode(e.target.value)} required />
        </div>
      </div>

      <div
        onClick={() => setSaveData(!saveData)}
        style={{ cursor: "pointer", display: "flex", alignItems: "center", maxWidth: "max-content", marginTop: 10 }}
      >
        <img alt="" src={saveData ? Ic_check : Ic_uncheck} draggable="false" style={{ paddingRight: 10, width: 17 }} />
        <p style={{ margin: 0, userSelect: "none", fontFamily: "m_semi_bold" }}>{"Guardar datos para siguiente compra"}</p>
      </div>
    </div>
  );
};

const Step1 = (props) => {
  const { setACoupon, setAuxShippingType, setLocalTotal, sell, setSell, store, rol, distClass, shipments, token, data, updateStore, saveToken } =
    props;
  const classes = useStyles();
  const history = useHistory();

  const [preferenceInfo, setPreferenceInfo] = useState({});

  const [coupon, setCoupon] = useState("");
  const [uses, setUses] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const [delivery, setDelivery] = useState(0);
  const [total, setTotal] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [discount, setDiscount] = useState(0);

  const [type, setType] = useState("");
  const [minimum, setMinimum] = useState(0);
  const [value, setValue] = useState(0);

  const [shippingType, setShippingType] = useState(rol === "Distribuitor" ? "NORMAL" : "SLOW");

  const [steps, setSteps] = useState(1);

  // ------------------------------------------------------------------------

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [numExt, setNumExt] = useState("");
  const [numInt, setNumInt] = useState("");
  const [state, setState] = useState("");
  const [municipality, setMunicipality] = useState("");
  const [area, setArea] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [email, setEmail] = useState("");

  const [saveData, setSaveData] = useState(true);

  const [totalProducts, setTotalProducts] = useState(0);

  // ------------------------------------------------------------------------

  const initialization = {
    amount: total,
    preferenceId: preferenceInfo?.id,
  };

  const customization = {
    paymentMethods: {
      // atm: "all",
      // ticket: "all",
      creditCard: "all",
      prepaidCard: "all",
      debitCard: "all",
      mercadoPago: "all",
    },
  };

  const handleSubmit = async () => {
    setLoading2(true);
    const userId = data.id;

    const obj = {
      role: rol,
      name: name.trim(),
      lastName: lastName.trim(),
      email: email.trim(),
      phone: phone.trim(),
      coupon: coupon.trim(),
      postalCode: postalCode.trim(),
      address: address.trim(),
      state: state.trim(),
      municipality: municipality.trim(),
      distribuitorClass: distClass,
      shippingType: shippingType,
      products: store,

      userId,

      area: area.trim(),
      numExt: numExt.trim(),
      numInt: numInt.trim(),
    };

    const res = await generatePayment(obj, token);
    if (res.status === 200) {
      setPreferenceInfo(res.response.saleInfo);
      setSteps(3);
      // shoppingId
    }

    setLoading2(false);
  };

  // ------------------------------------------------------------------------

  const onSubmit = async (param) => {
    console.log("onSubmit >>>>>>> ");
    console.log(param);
  };

  const onReady = async (param) => {
    console.log("onReady >>>>>>>");
    console.log(param);
  };

  const onError = async (param) => {
    console.log("onError >>>>>>>");
    console.log(param);
  };

  // ------------------------------------------------------------------------

  const deleteProduct = (position) => {
    let auxData = [];
    store.forEach((i, j) => {
      if (position !== j) {
        auxData.push(i);
      }
    });
    updateStore(auxData);
  };

  const decreaseTotal = (position) => {
    store.forEach((i, j) => {
      if (j === position) {
        if (i.total - 1 !== 0) {
          i.total -= 1;
        }
      }
    });
    updateStore([...store]);
  };

  const increaseTotal = (position) => {
    store.forEach((i, j) => {
      if (j === position) {
        i.total += 1;
      }
    });
    updateStore([...store]);
  };

  // ------------------------------------------------------------------------

  const validateCoupon = async () => {
    setLoading(true);
    const extra = `?coupon=${coupon}`;
    const token = "";
    const res = await searchCoupon(token, extra);
    if (res.data.data.id) {
      if (res.data.data.available) {
        if (uses === false) {
          if (subtotal >= res.data.data.minimum) {
            setUses(() => true);
            toast.success("Cupón aplicado.");
            setType(res.data.data.type);
            setMinimum(res.data.data.minimum);
            setValue(res.data.data.value);
            setACoupon(() => coupon);
          } else {
            toast.warn(`Cupón valido en la compra minima de $ ${formatMoney(res.data.data.minimum)}`);
          }
        } else {
          toast.warn("Ya se aplico el cupón.");
        }
      } else {
        toast.warn("El cupón expiro.");
      }
    } else {
      toast.warn("Cupón invalido.");
    }
    setLoading(false);
  };

  // ------------------------------------------------------------------------

  const calculateSubtotal = () => {
    let subtotal = 0;
    store.forEach((i, j) => {
      if (rol === "Distribuitor") {
        if (distClass === "a") {
          subtotal += i.distributorPrice * i.total;
        } else {
          subtotal += i.distributorPriceB * i.total;
        }
      } else {
        subtotal += i.publicPrice * i.total;
      }
    });
    setSubtotal(subtotal);
  };

  const calculateTotal = () => {
    let auxSubtotal = 0;
    // const shipping = delivery
    store.forEach((i, j) => {
      if (rol === "Distribuitor") {
        // auxSubtotal += i.distributorPrice * i.total
        if (distClass === "a") {
          auxSubtotal += i.distributorPrice * i.total;
        } else {
          auxSubtotal += i.distributorPriceB * i.total;
        }
      } else {
        auxSubtotal += i.publicPrice * i.total;
      }
    });
    let auxTotal = auxSubtotal;
    if (auxSubtotal >= minimum) {
      if (type === "PERCENT") {
        setDiscount(auxTotal * (value / 100));
        auxTotal = auxTotal - auxTotal * (value / 100);
      } else {
        setDiscount(value);
        auxTotal = auxTotal - value;
      }
    }
    // if(auxTotal<599){
    //     auxTotal += delivery
    //     const res = checkShipmet(rol, store, shipments)
    //     setDelivery(res.shipment)
    //     // setDelivery(()=>deliveryGlobal)
    // } else{
    //     setDelivery(()=>0)
    // }

    auxTotal += delivery;

    setTotal(() => auxTotal);
    setLocalTotal(() => auxTotal);
    // setAuxShippingType(() => shippingType);
  };

  useEffect(() => {
    calculateSubtotal();
    calculateTotal();
    const res = checkShipmet(rol, store, shipments, shippingType);

    setDelivery(res.shipment);
    setSell(res.sell);
    setTotalProducts(res.totalProducts);
  });

  return (
    <div style={{ padding: "10px 0" }}>
      <Header steps={steps} setSteps={sell === true ? setSteps : () => {}} />

      <div className={classes.container_table}>
        <Container maxWidth="xl">
          <div style={{ marginTop: 50 }}>
            <div style={{ display: steps === 1 ? "block" : "none", borderTop: `2px solid ${colors.gray}`, paddingTop: 10 }}>
              <Grid container>
                <Grid item xs={12} md={8}>
                  <div style={{ overflow: "auto" }}>
                    <Table>
                      <TableBody>
                        {store &&
                          store.map((item, index) => (
                            <TableRow key={`table-row-${index}`}>
                              <TableCell>
                                <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
                                  <Close onClick={() => deleteProduct(index)} />
                                  <img alt="" src={item.picture1} style={{ width: 80, height: 70, objectFit: "cover", userSelect: "none" }} />
                                </div>
                              </TableCell>
                              <TableCell>
                                <div>
                                  <p style={{ margin: 0, fontFamily: "av_book", userSelect: "none" }}>Upee</p>
                                  <p style={{ margin: 0, paddingTop: 3, fontSize: 24, fontFamily: "walfords", userSelect: "none" }}>{item.name}</p>
                                </div>
                              </TableCell>
                              <TableCell>
                                <p
                                  style={{ fontFamily: "av_book", userSelect: "none", whiteSpace: "nowrap" }}
                                >{`$ ${formatMoney(checkPrice(rol, distClass, item.distributorPrice, item.distributorPriceB, item.publicPrice))} MXN`}</p>
                              </TableCell>
                              <TableCell>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <Minus onClick={() => decreaseTotal(index)} />
                                  <div style={{ width: 32, textAlign: "center" }}>
                                    <p style={{ margin: 0, fontFamily: "m_semi_bold", userSelect: "none" }}>{item.total}</p>
                                  </div>
                                  <Plus onClick={() => increaseTotal(index)} />
                                </div>
                              </TableCell>
                              <TableCell>
                                <p
                                  style={{ fontFamily: "m_semi_bold", userSelect: "none", whiteSpace: "nowrap" }}
                                >{`$ ${formatMoney(checkPrice(rol, distClass, item.distributorPrice, item.distributorPriceB, item.publicPrice) * item.total)} MXN`}</p>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                    {sell === false && (
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <p style={{ fontSize: 25, fontFamily: "m_semi_bold", whiteSpace: "nowrap" }}>{"La compra mínima es de 100 productos"}</p>
                      </div>
                    )}

                    {totalProducts >= 10 && (
                      <div
                        style={{
                          margin: "20px 20px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          boxSizing: "border-box",
                        }}
                      >
                        <div style={{ width: "100%", padding: "15px 20px", background: colors.purple, boxSizing: "border-box" }}>
                          <p style={{ color: "white", fontFamily: "m_semi_bold", margin: 0 }}>
                            Por el número de piezas que estas comprando, te recomendamos inscribirte a nuestro programa de distribuidoras.
                          </p>
                          <button
                            onClick={() => history.push("/distribuidoras")}
                            type="button"
                            style={{
                              border: "none",
                              background: "transparent",
                              color: "white",
                              fontFamily: "m_extra_bold",
                              cursor: "pointer",
                              fontSize: 18,
                              padding: 0,
                              marginTop: 10,
                            }}
                          >
                            Más información
                          </button>
                        </div>
                        <img
                          alt=""
                          src={Img_distribution}
                          style={{ width: "100%", maxWidth: 120, height: 140, objectFit: "cover", objectPosition: "50% 20%" }}
                        />
                      </div>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Aside
                    steps={steps}
                    rol={rol}
                    sell={sell}
                    subtotal={subtotal}
                    coupon={coupon}
                    setCoupon={setCoupon}
                    validateCoupon={validateCoupon}
                    loading={loading}
                    discount={discount}
                    shippingType={shippingType}
                    setShippingType={setShippingType}
                    delivery={delivery}
                    total={total}
                    setSteps={() => setSteps(2)}
                    totalProducts={totalProducts}
                    loading2={loading2}
                  />
                </Grid>
              </Grid>
            </div>

            {token === "" && (
              <div style={{ display: steps === 2 ? "block" : "none" }}>
                <Login setSteps={setSteps} />
              </div>
            )}

            {token !== "" && (
              <div style={{ borderTop: `2px solid ${colors.gray}`, paddingTop: 30, display: steps >= 2 ? "block" : "none" }}>
                <Grid spacing={0} container>
                  {steps === 2 && (
                    <Grid item xs={12} md={8}>
                      <Grid container>
                        <Grid item xs={12} md={11}>
                          <Contact
                            data={data}
                            name={name}
                            setName={setName}
                            lastName={lastName}
                            setLastName={setLastName}
                            phone={phone}
                            setPhone={setPhone}
                            address={address}
                            setAddress={setAddress}
                            numExt={numExt}
                            setNumExt={setNumExt}
                            numInt={numInt}
                            setNumInt={setNumInt}
                            state={state}
                            setState={setState}
                            municipality={municipality}
                            setMunicipality={setMunicipality}
                            area={area}
                            setArea={setArea}
                            postalCode={postalCode}
                            setPostalCode={setPostalCode}
                            email={email}
                            setEmail={setEmail}
                            saveData={saveData}
                            setSaveData={setSaveData}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  <Grid item xs={12} md={steps === 2 ? 4 : 12}>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div style={{ maxWidth: steps === 2 ? 1500 : 550, width: "100%" }}>
                        <Aside
                          steps={steps}
                          rol={rol}
                          sell={sell}
                          subtotal={subtotal}
                          coupon={coupon}
                          setCoupon={setCoupon}
                          validateCoupon={validateCoupon}
                          loading={loading}
                          discount={discount}
                          shippingType={shippingType}
                          setShippingType={setShippingType}
                          delivery={delivery}
                          total={total}
                          setSteps={() => handleSubmit()}
                          totalProducts={totalProducts}
                          loading2={loading2}
                        >
                          <div style={{ marginTop: 30, display: steps === 3 ? "block" : "none" }}>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                              <div style={{ maxWidth: 500, width: "100%" }}>
                                {preferenceInfo.id && (
                                  <Wallet
                                    initialization={{ preferenceId: preferenceInfo.id }}
                                    customization={{ texts: { valueProp: "smart_option" } }}
                                    onSubmit={onSubmit}
                                    onReady={onReady}
                                    onError={onError}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </Aside>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  store: state.Store.data,
  rol: state.Panel.rol,
  distClass: state.Panel.data.distribuitorClass,
  shipments: state.Panel.shipments,
  token: state.Panel.token,
  data: state.Panel.data,
});

export default connect(mapStateToProps, { updateStore, saveToken })(Step1);
